<template>
  <div>
    <div class="page-wrapper">
      <div class="container-fluid">
        <!-- sign up page start-->
        <div class="auth-bg-video">
          <video id="bgvid" poster="../assets/images/other-images/coming-soon-bg.jpg" playsinline=""
                 autoplay="" muted="" loop="">
            <source src="../assets/video/auth-bg.mp4" type="video/mp4">
          </video>
          <div class="authentication-box">
            <div class="text-center"><img alt="" src="../assets/images/logo-dark.png" width="150"></div>
            <div class="card mt-4 p-4">
              <h4 class="text-center text-uppercase">Sign up for Access to Upgraded Plan</h4>
              <form class="theme-form" @submit.prevent="handleSubmit">
                <div class="form-group">
                  <label for="firstName" class="col-form-label">First Name</label>
                  <input type="text" v-model="user.firstName" id="firstName" name="firstName"
                         class="form-control"
                         :class="{ 'is-invalid': submitted && $v.user.firstName.$error }"/>
                  <div v-if="submitted && !$v.user.firstName.required"
                       class="invalid-feedback">First Name is required
                  </div>
                </div>
                <div class="form-group">
                  <label for="lastName" class="col-form-label">Last Name</label>
                  <input type="text" v-model="user.lastName" id="lastName" name="lastName"
                         class="form-control"
                         :class="{ 'is-invalid': submitted && $v.user.lastName.$error }"/>
                  <div v-if="submitted && !$v.user.lastName.required"
                       class="invalid-feedback">Last Name is required
                  </div>
                </div>
                <div class="form-group">
                  <label for="email" class="col-form-label">Email</label>
                  <input type="email" v-model="user.email" id="email" name="email"
                         class="form-control"
                         :class="{ 'is-invalid': submitted && $v.user.email.$error }"/>
                  <div v-if="submitted && $v.user.email.$error" class="invalid-feedback">
                    <span v-if="!$v.user.email.required">Email is required</span>
                    <span v-if="!$v.user.email.email">Email is invalid</span>
                  </div>
                </div>
                <div class="form-group">
                  <label for="referralCode" class="col-form-label">Referral Code</label>
                  <input type="text" v-model="user.referralCode" id="referralCode"
                         name="confirmPassword" class="form-control"/>
                </div>
                <div class="form-group">
                  <label for="referralCode" class="col-form-label">Card</label>
                  <div ref="card"></div>
                </div>
                <div class="form-row">
                  <div class="col-sm-12">
                    <div class="loading-wrapper">
                      <div class="btn-loading" v-if="loading">
                        <div class="lds-ring">
                          <div></div>
                          <div></div>
                          <div></div>
                          <div></div>
                        </div>
                      </div>
                      <div class="loading-wrapper">
                        <div class="btn-loading" v-if="loading">
                          <div class="lds-ring"><div></div><div></div><div></div><div></div></div>
                        </div>
                        <button class="btn btn-primary">Subscribe ${{amount / 100}}</button>
                      </div>
                    </div>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
        <!-- sign up page ends-->

        <div class="registration_confirmation-wrapper" :class="{'show': showModal}">
          <div class="registration_confirmation-box">
            <div class="text-center mb-4"><img src="../assets/images/logo-dark.png" width="150" alt=""></div>
            <div class="registration_confirmation card">
              <div class="card-body">
                <div class="f-w-100 d-flex justify-content-center">
                  <img src="../assets/images/fireworks.png" width="150" alt="">
                </div>
                <p class="mt-3">
                  Congratulations on joining our community!<br>
                  Now you can install App
                </p>
                <div class="form-group text-center">
                  <a style="cursor: pointer; width: 226px; height: 76px;"
                     href="https://apps.apple.com/us/app/id1516315709" target="_blank">
                    <img src="../assets/images/download_on_the_App_Store.svg" width="200" alt="">
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import {required, email} from "vuelidate/lib/validators";
  import loadScript from "../services/loadScript";
  import stripeScript from '../services/stripe';
  import stripeApi from "../services/stripeApi";

  //test key
  // let stripe   = Stripe(`pk_test_51Gtv3YEDRdIX0VZCigLbdTcMitH71DS5JTy5I7aWWEwZ2zQXGzaBbKZdZ0HliT7tinmkPbu2XYAKWEohv4Y8tFwY000dosV41z`),
  //live key
  let elements = undefined;
  let stripe = undefined;
  if (window.Stripe){
    stripe = window.Stripe(`pk_live_0hVYOwudlaN8PDcKJHr4wRft`),
    stripe.elements()
  }
  let card = undefined;

  export default {
    data() {
      return {
        user: {
          firstName: "",
          lastName: "",
          email: "",
          referralCode: ""
        },
        submitted: false,
        loading: false,
        showModal: false,
        amount: 6000,
        token: null,
        charge: null,
        loadong: false
      };
    },
    validations: {
      user: {
        firstName: {required},
        lastName: {required},
        email: {required, email},
      }
    },
    created() {
      loadScript(() => {
        card         = elements.create('card');
        card.mount(this.$refs.card);
      }, stripeScript);
    },
    methods: {
      handleSubmit() {
        this.submitted = true;

        this.$v.$touch();
        if (this.$v.$invalid) {
          return;
        }

        this.loading = true;

        let self = this;

        stripe.createToken(card).then(function(result) {
          if (result.error) {
            self.hasCardErrors = true;
            self.$forceUpdate(); // Forcing the DOM to update so the Stripe Element can update.
            self.loading = false;
            return;
          }
          stripeApi.getClientSecret(self.amount).then((val) => {
            stripe
              .confirmCardPayment(val.data.value.clientSecret, {
                payment_method: {
                  card: card,
                  billing_details: {
                    name: self.user.firstName + ' ' + self.user.lastName,
                    email: self.user.email
                  },
                },
              }).then(() => {
                let user = {
                  "firstName": self.user.firstName,
                  "lastName": self.user.lastName,
                  "email": self.user.email,
                  "referralCode": self.user.referralCode
                };

                self.$store.dispatch('registerClient', user).then((res) => {
                  if (res.status === 200) {
                    stripeApi.confirmPayment(self.user.email).then(() => {
                      self.$router.push('?status=success');
                      self.loading = false;
                    }).catch(() => {
                      self.loading = false;
                      self.$toasted.show(' Please try again ', {
                        theme: 'bubble',
                        position: "bottom-right",
                        type: 'error',
                        duration: 2000
                      });
                    })
                  } else {
                    self.loading = false;
                    self.$toasted.show(' Please try again ', {
                      theme: 'bubble',
                      position: "bottom-right",
                      type: 'error',
                      duration: 2000
                    });
                  }
                })
              }).catch(() => {
                self.loading = false;
                self.$toasted.show(' Please try again ', {
                  theme: 'bubble',
                  position: "bottom-right",
                  type: 'error',
                  duration: 2000
                });
            })
          }).catch(() => {
            self.loading = false;
            self.$toasted.show(' Please try again ', {
              theme: 'bubble',
              position: "bottom-right",
              type: 'error',
              duration: 2000
            });
          })
        });
      },
      async init() {
        if (this.$route.params.code) {
          this.user.referralCode = this.$route.params.code;
        } else {
          this.$router.push({name: 'default'});
        }
      },
    },
    watch: {
      '$route.params': {
        immediate: true,
        handler() {
          window.scrollTo(0, 0);
          this.init();
        }
      },
      '$route.query': {
        immediate: true,
        handler() {
          this.showModal = this.$route.query.status === 'success';
        }
      }
    },
  }
</script>

<style scoped lang="scss">
  .loading-wrapper {
    position: relative;

    button {
      width: 100%;
    }

    .btn-loading {
      position: absolute;
      top: 0;
      right: 0;
      bottom: 0;
      left: 0;
      z-index: 1;
      background: rgba(255, 255, 255, 0.55);
      display: flex;
      align-items: center;
      justify-content: center;
    }

    .lds-ring {
      display: inline-block;
      position: relative;
      width: 25px;
      height: 25px;
    }
    .lds-ring div {
      box-sizing: border-box;
      display: block;
      position: absolute;
      width: 25px;
      height: 25px;
      border: 3px solid #fff;
      border-radius: 50%;
      animation: lds-ring 1.2s cubic-bezier(0.5, 0, 0.5, 1) infinite;
      border-color: #fff transparent transparent transparent;
    }
    .lds-ring div:nth-child(1) {
      animation-delay: -0.45s;
    }
    .lds-ring div:nth-child(2) {
      animation-delay: -0.3s;
    }
    .lds-ring div:nth-child(3) {
      animation-delay: -0.15s;
    }
    @keyframes lds-ring {
      0% {
        transform: rotate(0deg);
      }
      100% {
        transform: rotate(360deg);
      }
    }
  }
  /**
 * The CSS shown here will not be introduced in the Quickstart guide, but shows
 * how you can use CSS to style your Element's container.
 */
  .registration_confirmation-wrapper {
    position: fixed;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    z-index: 111;
    background-color: #f8f8f8;
    opacity: 0;
    visibility: hidden;
    transition: 0.3s;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .registration_confirmation-wrapper.show {
    opacity: 1;
    visibility: visible;
  }

  .registration_confirmation-wrapper .registration_confirmation {
    width: 600px;
  }

  .registration_confirmation-wrapper .registration_confirmation p {
    font-size: 18px;
    text-align: center;
    color: #494949;
  }

  .registration_confirmation-wrapper .registration_confirmation .card-footer {
    user-select: none;
    cursor: pointer;
  }

  .page-wrapper {
    min-height: 100vh;
    display: flex;
    align-items: center;
  }

  .authentication-main .auth-innerright {
    min-height: auto !important;
  }

  .authentication-main {
    min-height: 100vh;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  @media (max-width: 600px) {
    .registration_confirmation-box {
      width: 100%;
    }

    .registration_confirmation-wrapper {
      padding: 0 15px;
    }

    .registration_confirmation-wrapper .registration_confirmation {
      width: 100%;
    }

    .registration_confirmation-wrapper .registration_confirmation h3 {
      font-size: 20px;
    }

    .registration_confirmation-wrapper .registration_confirmation p {
      font-size: 16px;
    }
  }
</style>
